import ClubFeeCategory from './ClubFeeCategory';
import ClubImpersonalAccount from './ClubImpersonalAccount';
import Department from './Department';
import PricePerTime from './PricePerTime';

export default class ClubSalesListItem {
    static fromData(data) {
        if (!data) {
            return;
        }

        const clubSalesListItem = new ClubSalesListItem();
        clubSalesListItem.id = data.id;
        clubSalesListItem.name = data.name;
        clubSalesListItem.department = data.department !== null ? Department.fromData(data.department) : null;
        clubSalesListItem.category = data.category !== null ? ClubFeeCategory.fromData(data.category) : null;
        clubSalesListItem.impersonalAccount = data.impersonalAccount !== null ? ClubImpersonalAccount.fromData(data.impersonalAccount) : null;
        clubSalesListItem.pricePerTime = PricePerTime.fromData(data.pricePerTime.data);
        clubSalesListItem.chargeCredit = data.chargeCredit;
        clubSalesListItem.count = null;

        return clubSalesListItem;
    }
}
